<template>
  <div>
    <el-button type="primary" @click="$router.go(-1)">返回上一级</el-button>
    <div class="details">
      <li class="title">基本信息：</li>
      <div class="details_warp">
        <el-image
          fit="cover"
          :src="$utils.fileUrl(data.logo)"
          :preview-src-list="[`${$utils.fileUrl(data.logo)}`]"
        >
        </el-image>

        <ul>
          <li>
            <span><b>用户名称：</b>{{ data.name }}</span>
          </li>
          <li>
            <span><b>法定代表人：</b>{{ data.legalPerson }}</span>
            <span
              ><b>统一社会信用代码：</b>{{ data.unifiedSocialCreditCode }}</span
            >
          </li>
          <li>
            <span><b>证件类型：</b>{{ idType(data.idType) }}</span>
            <span><b>证件号码：</b>{{ data.idCard || "-" }}</span>
          </li>
          <li>
            <span
              ><b>所属地区：</b>{{ data.province }}{{ data.city
              }}{{ data.area }}</span
            >
            <span
              ><b>所属行业：</b>{{ data.firstIndustryName
              }}{{ data.secondIndustryName }}{{ data.area }}</span
            >
          </li>
          <li>
            <span><b>认证日期：</b>{{ $utils.formatDate(data.applyTime) }}</span
            ><span
              ><b>审核日期：</b>{{ $utils.formatDate(data.auditTime) }}</span
            >
          </li>
          <li>
            <span><b>创建账号：</b>{{ data.username }}</span>
            <span><b>保荐人：</b>{{ data.inviter || "-" }}</span>
            <span><b>保荐码：</b>{{ data.invitationCode }}</span>
          </li>
        </ul>
      </div>
      <li class="title">用户上传的资料图（缩略图）：</li>
      <div class="details_warp——img">
        <el-image
          fit="cover"
          v-if="data.businessLicense"
          :src="$utils.fileUrl(data.businessLicense)"
          :preview-src-list="[
            `${$utils.fileUrl(data.businessLicense)}`,
            `${$utils.fileUrl(data.powerOfAttorney)}`,
          ]"
        >
        </el-image>
        <el-image
          fit="cover"
          v-if="data.powerOfAttorney"
          :src="$utils.fileUrl(data.powerOfAttorney)"
          :preview-src-list="[
            `${$utils.fileUrl(data.businessLicense)}`,
            `${$utils.fileUrl(data.powerOfAttorney)}`,
          ]"
        >
        </el-image>
      </div>
      <el-divider></el-divider>
      <div class="footer">
        <div class="f_header">
          <li>平台信息</li>
        </div>
        <div class="f_content">
          <ul class="f_content_one">
            <li><span>保荐码：</span>{{ data.invitationCode }}</li>
            <li><span>保荐人：</span>{{ data.inviter || "-" }}</li>
            <li><span>推广人数：</span>{{ data.invitationCount || "-" }}</li>
          </ul>
          <ul class="f_content_one">
            <!-- <li><span>会员积分：</span>XXXXX</li> -->
            <li><span> 员工数量： </span>{{ data.employeeCount || "-" }}人</li>
          </ul>
          <!-- <ul class="f_content_one">
            <li><span>收益（万元）：</span>XXXXX</li>
            <li><span>累计消费金额：</span>XXXXX</li>
          </ul> -->
          <ul class="f_content_one">
            <li><span>会员等级：</span>{{ data.memberName }}</li>
            <li>
              <button @click="change_dialog = true">手动变更</button>
            </li>
          </ul>
          <ul class="f_content_one" v-if="data.memberName != '注册会员'">
            <li>
              <span> 会员到期： </span
              >{{ $utils.formatDate(data.manualEndTime) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog
      title="变更会员等级"
      v-model="change_dialog"
      width="600px"
      center
    >
      <div class="change_dialog">
        <li class="change_dialog_one">当前会员等级：{{ data.memberName }}</li>
        <li class="change_dialog_one">
          会员有效期至：{{ $utils.formatDate(data.manualEndTime) }}
        </li>
        <el-divider></el-divider>
        <li class="change_dialog_one">套餐：</li>
        <li class="change_dialog_radio">
          <div
            v-for="item in data.optionalMembershipPackageList"
            :key="item.package_id"
          >
            <el-radio v-model="radio" :label="item.member_level">{{
              item.member_name
            }}</el-radio>
          </div>
        </li>
        <li class="change_dialog_picker" v-if="radio != 0">
          <span> 有效期至： </span>
          <el-date-picker
            v-model="time"
            type="date"
            format="YYYY-MM-DD"
            placeholder="选择日期"
            :disabled-date="disabledDate"
          >
          </el-date-picker>
        </li>
      </div>
      <template #footer>
        <span class="dialog_footer">
          <button @click="change_dialog = false">取消</button>
          <button @click="reject">确认</button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      itemData: {},
      editVisible: false,
      loading: false,
      reject_dialog: false,
      auditRemark: "",
      idCard: "",
      userName: "",
      change_dialog: false,

      radio: "",

      time: "",
      packageId: "",

      disabledDate(time) {
        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
      },
    };
  },

  methods: {
    async getData() {
      const params = {
        id: this.$route.params.id,
      };
      this.$loading.start();
      const res = await this.$api.account.getCompanyDetails(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
        res.data.optionalMembershipPackageList.forEach((item, index) => {
          if (item.check_state === 1) {
            this.radio = item.member_level;
          }
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "护照";
        case 3:
          return "其他";
      }
    },
    reject() {
      this.data.optionalMembershipPackageList.forEach((item, index) => {
        if (this.radio == item.member_level) {
          this.packageId = item.package_id;
        }
      });

      this.$loading.start();
      var params = {};
      if (this.radio == 0) {
        params = {
          type: 2,
          packageId: this.packageId,
          memberLevel: this.radio,
          memberTargetId: this.$route.params.id,
        };
      } else {
        if (!this.time) {
          this.$message.warning("请选择有效期!");
          return false;
        }
        var dayjs = require("dayjs");
        let time = dayjs(this.time).format("YYYY-MM-DD");
        params = {
          type: 2,
          packageId: this.packageId,
          memberLevel: this.radio,
          memberTargetId: this.$route.params.id,
          manualEndTime: time,
        };
      }

      this.$api.manualChange.addChange(params).then((res) => {
        this.$loading.done();
        if (res.code === 10200) {
          this.$message.success("添加成功");
          this.type = "";
          this.packageId = "";
          this.memberLevel = "";
          this.memberTargetId = "";
          this.manualEndTime = "";
          this.change_dialog = false;
        } else {
          this.$message.error(res.msg);
        }
        this.getData();
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.details {
  margin-top: 24px;
  padding: 24px;
  background-color: #ffffff;

  .title {
    font-weight: 500;
    margin-bottom: 15px;
    font-size: 1.125rem;
  }

  .details_warp {
    display: flex;
    margin-bottom: 33px;
    align-items: center;

    .el-image {
      width: 150px;
      height: 150px;
      margin-right: 24px;
    }

    ul {
      li {
        display: flex;
        height: 38px;
        align-items: center;

        span {
          color: #666666;
          min-width: 230px;
          margin-right: 24px;
          font-size: 0.875rem;
          b {
            font-size: 1rem;
            color: #333333;
            font-weight: 500;
          }
        }
      }
    }
  }

  .details_warp——img {
    .el-image {
      width: 300px;
      height: 200px;
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }
  .footer {
    .f_header {
      height: 64px;
      border-radius: 4px 4px 0 0;
      background: #f2f6fc;
      padding: 0 24px;
      li {
        width: 65px;
        font-size: 1rem;
        font-weight: bold;
        line-height: 64px;
        border-bottom: 2px solid #5693ff;
      }
    }
    .f_content {
      margin-top: 24px;
      margin-left: 24px;
      .f_content_one {
        display: flex;
        li {
          color: #666666;
          line-height: 40px;
          margin-right: 36px;
          font-size: 0.875rem;
          span {
            width: 65px;
            font-size: 1rem;
            font-weight: bold;
            color: #333;
          }
          button {
            width: 120px;
            height: 32px;
            line-height: 32px;
            background: #5693ff;
            color: #ffffff;
            border: none;
            outline: none;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
.change_dialog {
  .change_dialog_one {
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: bold;
    color: #333333;
  }
  .change_dialog_radio {
    display: flex;
    flex-direction: column;
    .el-radio {
      margin: 12px 64px;
    }
  }
  .change_dialog_picker {
    span {
      font-size: 1rem;
      font-weight: bold;
      color: #333333;
    }
  }
}
.dialog_footer {
  button {
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: #5693ff;
    color: #ffffff;
    border: none;
    outline: none;
    border-radius: 4px;
    margin-right: 24px;
  }
  button:nth-child(1) {
    background: #fff;
    color: #666666;
    border: 1px solid #666666;
  }
}
</style>